"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

var ExternalLink = ( /*#__PURE__*/0, _styledBase["default"])(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_.Link, (0, _extends2["default"])({
    rel: "noopener noreferrer",
    target: "_blank",
    title: "Link opens in new window",
    color: "greys.charcoal"
  }, props));
}, {
  target: "eoxqs090",
  label: "ExternalLink"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0V4dGVybmFsTGluay9FeHRlcm5hbExpbmsuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWUUiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRXh0ZXJuYWxMaW5rL0V4dGVybmFsTGluay5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBMaW5rIH0gZnJvbSAnLi4vJztcblxuY29uc3QgRXh0ZXJuYWxMaW5rID0gc3R5bGVkKChwcm9wcykgPT4gKFxuICA8TGlua1xuICAgIHJlbD1cIm5vb3BlbmVyIG5vcmVmZXJyZXJcIlxuICAgIHRhcmdldD1cIl9ibGFua1wiXG4gICAgdGl0bGU9XCJMaW5rIG9wZW5zIGluIG5ldyB3aW5kb3dcIlxuICAgIGNvbG9yPVwiZ3JleXMuY2hhcmNvYWxcIlxuICAgIHsuLi5wcm9wc31cbiAgLz5cbikpYGA7XG5cbkV4dGVybmFsTGluay5wcm9wVHlwZXMgPSBMaW5rLnByb3BUeXBlcztcblxuZXhwb3J0IGRlZmF1bHQgRXh0ZXJuYWxMaW5rO1xuIl19 */");
ExternalLink.propTypes = _.Link.propTypes;
var _default = ExternalLink;
exports["default"] = _default;